<!--  -->
<template>
  <div
    class="code-form"
    id="codeForm"
    style="
      width: 6.1rem;
      margin: 0 auto;
      padding: 0.3rem 0.5rem;
      background: #ffffff;
      box-shadow: 0px 2px 14px 0px rgba(12, 2, 3, 0.22);
      border-radius: 8px;
    "
  >
    <div class="legend" style="text-align: center; color: #363636">
      请输入验证码
    </div>
    <div class="codeInputs stm">
      <input type="number" maxlength="4" pattern="[0-9]*" autocomplete="off" />
    </div>
    <div class="assets">
      <div class="msg" style="width: 100%; text-align: center"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {},
};
</script>
<style lang='less' scoped>
.block {
  width: 6.1rem;
  margin: 0 auto;
  padding: 0.3rem 0.5rem;
  background: rgba(42, 52, 71, 0.8);

  margin-left: 0.2rem;
  font-size: 0.32rem;
  height: 0.32rem;
  align-items: center;
  width: 2rem;
  width: 100%;
  background-color: #fff;
  padding: 0.3rem;
  color: #5a5e66;
  text-align: center;
  padding: 0.2rem;
  margin: 0 auto;
  margin-right: 15px;
  margin-top: 0.6rem;
  line-height: 0.54rem;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/test.vue